var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{attrs:{"name":_vm.code,"group":"games","inline":_vm.inline}})
}
var staticRenderFns = []

export { render, staticRenderFns }